export const ACCESS_TOKEN_LOC_KEY = "Zino_app_user";
